import { render, staticRenderFns } from "./ReceiverItemEditDetailsPage.vue?vue&type=template&id=475ffd96&scoped=true&"
import script from "./ReceiverItemEditDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ReceiverItemEditDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475ffd96",
  null
  
)

export default component.exports